export default __webpack_public_path__ + "static/media/plate-example.00f0bccd.png";